(self["webpackChunkgrowwwtoday"] = self["webpackChunkgrowwwtoday"] || []).push([["/app"],{

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bootstrap/js/dist/modal */ "./node_modules/bootstrap/js/dist/modal.js");
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./toggles */ "./src/js/toggles.js");
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_toggles__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! js-cookie */ "./node_modules/js-cookie/dist/js.cookie.mjs");
/* harmony import */ var _fancyapps_fancybox_dist_jquery_fancybox_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @fancyapps/fancybox/dist/jquery.fancybox.js */ "./node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js");
/* harmony import */ var _fancyapps_fancybox_dist_jquery_fancybox_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_fancyapps_fancybox_dist_jquery_fancybox_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _fancyapps_fancybox_dist_jquery_fancybox_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @fancyapps/fancybox/dist/jquery.fancybox.css */ "./node_modules/@fancyapps/fancybox/dist/jquery.fancybox.css");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");






window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var mq = {
  xxs: 0,
  xs: 380,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 1800
};

// Site notice
function checkSiteNotice() {
  // Check the notice if it should be shown
  if (!js_cookie__WEBPACK_IMPORTED_MODULE_3__["default"].get("site-notice-hidden") || js_cookie__WEBPACK_IMPORTED_MODULE_3__["default"].get("site-notice-hidden") !== "true") {
    $(".js-sitenotice").removeClass("d-none");
  }
}

// On click js-close-notice use js-cookie to set "notice-hidden" cookie to true and hide the notice
$(document).on("click", ".js-sitenotice-close", function () {
  // Set cookie and hide notice
  js_cookie__WEBPACK_IMPORTED_MODULE_3__["default"].set("site-notice-hidden", "true", {
    expires: 1
  });
  $(".js-sitenotice").addClass("d-none");
});
checkSiteNotice();
$(document).ready(function () {
  var $scrollContainer = $(".main__inner");
  var $nav = $(".nav");
  $scrollContainer.on("scroll", function () {
    if ($scrollContainer.scrollTop() > 40) {
      $nav.addClass("scrolled");
    } else {
      $nav.removeClass("scrolled");
    }
  });
});
function replaceMenu() {
  if ($(window).width() < mq.xl) {
    $(".js-panel").prepend($(".js-nav-menu"));
    $(".js-panel").prepend($(".js-nav-actions-innner"));
    changeFilter();
  } else {
    $(".js-nav-menu--wrapper").append($(".js-nav-menu"));
    $(".js-nav-actions").prepend($(".js-nav-actions-innner"));
  }
}
replaceMenu();
$(window).on("resize", function () {
  replaceMenu();
});
$(".js-home-beer-slider").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  centerMode: false,
  arrows: false,
  responsive: [{
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 1.5,
      infinite: false
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.2,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: false
    }
  }]
});
$(".js-related-products").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  infinite: true,
  arrows: true,
  responsive: [{
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 1.5,
      infinite: false
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.2,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: false
    }
  }]
});
$(".js-content-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1.2
    }
  }]
});
$(".js-home-news").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  centerMode: false,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1.2
    }
  }]
});
$(document).on("click", ".js-faq-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(this).next().stop().slideToggle(300);
});
$(document).on("click", ".js-submenu-click", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(this).parent().next().stop().slideToggle(300);
});
function changeFilter() {
  var windowWidth = $(window).width();
  if (windowWidth < mq.lg) {
    $(".js-drawer-filter").prepend($(".js-collection-filters"));
    $(".js-drawer-filter").prepend($(".js-head-filter"));
  } else {
    // closeFilterPanel();
    $(".js-filtering").append($(".js-head-filter"));
    $(".js-filtering").append($(".js-collection-filters"));
  }
}
changeFilter();

// Filterpanel openen/sluiten
$(document).on("click", ".js-filter-panel", function (e) {
  openFilterPanel();
});
$(document).on("click", ".js-drawer-filter-close", function (e) {
  openFilterPanel();
});
var openFilterPanel = function openFilterPanel() {
  $(".drawer-filter").toggleClass("is-open");
};
var closeFilterPanel = function closeFilterPanel() {
  $(".drawer-filter").removeClass("is-open");
};
document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector(this.getAttribute("href")).scrollIntoView({
      behavior: "smooth"
    });
  });
});

/***/ }),

/***/ "./src/js/sliders.js":
/*!***************************!*\
  !*** ./src/js/sliders.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-slider */ "./node_modules/slick-slider/slick/slick.js");
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_slider__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");

$(document).ready(function () {
  // Hoofdafbeelding slider
  $('.js-product-hero-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.js-product-hero-thumbs'
  });

  // Thumbnail navigatie slider
  $('.js-product-hero-thumbs').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.js-product-hero-slider',
    dots: false,
    rows: 1,
    focusOnSelect: true,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  // Variatie selectie om naar de juiste afbeelding te sliden
  $('#variant-select').on('change', function () {
    // Haal de index op van de geselecteerde variatie
    var selectedIndex = $(this).find(':selected').data('variant-index');

    // Schakel de hoofdafbeelding naar de corresponderende slide
    $('.js-product-hero-slider').slick('slickGoTo', selectedIndex);
  });
});

/***/ }),

/***/ "./src/js/toggles.js":
/*!***************************!*\
  !*** ./src/js/toggles.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
$(document).on("click", ".js-nav-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $("html").toggleClass("show-nav");
});
$(document).on("click", ".js-lang-toggle", function (e) {
  e.preventDefault();
  $("html").addClass("show-lang");
});
$(document).on("click", ".js-lang-close", function (e) {
  e.preventDefault();
  $("html").removeClass("show-lang");
});
$(document).on("click", ".js-footer-toggle ", function (e) {
  e.preventDefault();
  $(this).parent().toggleClass("is-active");
  $(this).parent().next("nav").children("ul").stop().slideToggle();
});
$(document).on("click", ".js-collection-filter-toggle", function () {
  var parent = $(this).parent();
  var content = parent.find(".collection-filter-content");
  parent.toggleClass("is-hidden"); // voegt toe/verwijdert 'is-hidden'
  content.stop().slideToggle(); // toggle animatie
});

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["app","/vendor"], () => (__webpack_exec__("./src/js/app.js"), __webpack_exec__("./src/scss/app.scss")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);